import React from "react";
import styled, { css } from "styled-components";
const Wrapper = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33%;
    padding: 30px;
    max-width: 440px;
    min-width: 330px;
  `
);
const Container = styled.div`
  width: 100%;
`;
const LoginBox = ({ children }) => /* @__PURE__ */ React.createElement(Wrapper, { className: "container" }, /* @__PURE__ */ React.createElement(Container, null, children));
export default LoginBox;
